import Vue from 'vue'
import { getItem, setItem, Get } from 'kjqk-commons/src/common/index.js'
// import permission from '@/router/permission.js'
import v4 from 'uuid'
let userInfo = {
  email: '',
  hasMagazine: '1',
  imgPath: '',
  isLogin: '1',
  isbind: '1',
  loginName: 'zhao123',
  mobile: '18301308700',
  orgId: '674',
  orgName: '迭代1218（对象存储）',
  realId: 'd3212696de3f4198bf40e75b86a9d338',
  role: '0',
  transferProtocol: '1',
  userId: '1460',
  userName: '赵海欢'
}
let isFireFox = 'noFireFox'
let storeTreeObj = {}
let magazineId = null
let handler = ''
let wsObj = {}
let ws = {}
// websocket 初始化
function initWs() {
  // 开发环境
  // ws = new WebSocket('ws://172.19.32.108:8080/websocket/socketServer.do')
  // 发布环境
  let protocol =
    location.protocol === 'https:'
      ? 'wss://' + window.location.host + '/websocket/socketServer.do'
      : 'ws://' + window.location.host + '/websocket/socketServer.do'
  ws = new WebSocket(protocol)
  // 建立 web socket 连接成功触发事件
  ws.onopen = function() {
    // 使用 send() 方法发送数据
    if (sessionStorage.getItem('_userInfo')) {
      console.log('数据已发送')
      ws.send('发送数据')
    }
  }
  // 接收服务端数据时触发事件
  ws.onmessage = function(evt) {
    console.log('数据已接收', evt)
    wsObj = evt
    if (store.state.wsObj) {
      store.state.wsObj = wsObj
    }
  }
  ws.onclose = function() {
    initWs()
  }
}
if (sessionStorage.getItem('_userInfo')) {
  userInfo = JSON.parse(getItem('_userInfo'))
  initWs()
}
if (sessionStorage.getItem('isFireFox')) {
  isFireFox = sessionStorage.getItem('isFireFox')
}
if (sessionStorage.getItem('magazineId')) {
  magazineId = sessionStorage.getItem('magazineId')
}
if (sessionStorage.getItem('handler')) {
  handler = sessionStorage.getItem('handler')
}
if (sessionStorage.getItem('storeTreeObj')) {
  storeTreeObj = JSON.parse(sessionStorage.getItem('storeTreeObj'))
}
const store = {
  namespaced: true,
  state: {
    isFireFox: isFireFox, // 兼容火狐样式
    userInfo: userInfo,
    menuPermission: {},
    buttonPermission: {},
    isSaveSessionStorage: false,
    magazineId: magazineId,
    uploaderState: {}, // webuploader实例
    handler: handler, // 记录当前处理人
    storeTreeObj: storeTreeObj, // 记录组刊中心树节点展开情况
    ws: ws, // websocket实例
    wsObj: wsObj, // websocket返回消息内容
    fileMagazinedArray: [], // 需要上传的文件数组
    finishCount: 0,
    filePercentageObj: {},
    comchangeBtnPerm: ''
  },
  getters: {
    userInfo: (state) => state.userInfo,
    isFireFox: (state) => state.isFireFox,
    ws: (state) => state.ws,
    wsObj: (state) => state.wsObj,
    isSaveSessionStorage: (state) => state.isSaveSessionStorage,
    menuPermission: (state) => state.menuPermission,
    buttonPermission: (state) => state.buttonPermission
  },
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setIsIe(state, isFireFox) {
      state.isFireFox = isFireFox
    },
    setMagazineId(state, magazineId) {
      state.magazineId = magazineId
    },
    setHandler(state, handler) {
      state.handler = handler
    },
    updateMenuPermission: (state, payload) => {
      state.menuPermission = payload.menuPermission || {}
      state.buttonPermission = payload.buttonPermission || {}
    },
    updateSave: (state, value) => {
      state.isSaveSessionStorage = value + new Date().getTime()
    },
    comchangeBtnPerm: (state, value) => {
      state.comchangeBtnPerm = value
    },
    updateUploaderState: (state, value) => {
      state.uploaderState = value
    },
    // 要上传的文件数据整理--- 需要给每个文件设置uuid及刊物id
    updateFileArr: (state, arr) => {
      for (let i = 0; i < arr.length; i++) {
        let uuid = v4()
        arr[i].uuid = uuid
        arr[i].isTimeout = false
      }
      state.fileMagazinedArray = state.fileMagazinedArray.concat(arr)
    },
    setTreeObj: (state, value) => {
      state.storeTreeObj = value
    },
    clearState: (state) => {
      state.userInfo = {}
      state.menuPermission = {}
      state.buttonPermission = {}
      state.isSaveSessionStorage = false
      state.magazineId = null
      state.magazineName = ''
      state.uploaderState = {}
      state.fileMagazinedArray = []
      state.handler = ''
      state.storeTreeObj = {}
      state.ws = {}
      state.wsObj = {}
      state.filePercentageObj = {}
    }
  },
  actions: {
    userInfo({ commit }, userInfo) {
      commit('setUserInfo', userInfo)
    },
    isFireFox({ commit }, isFireFox) {
      commit('setIsIe', isFireFox)
    },
    magazineId({ commit }, magazineId) {
      commit('setMagazineId', magazineId)
    },
    handler({ commit }, value) {
      commit('setHandler', value)
    },
    treeObj({ commit }, value) {
      commit('setTreeObj', value)
    },
    save({ commit }, value) {
      commit('updateSave', value)
    },
    queryPerm: ({ commit, dispatch }, val) => {
      let params = val
      Get('/magazine/menuPermList.do', { params: params }).then((response) => {
        if (response.data && response.data.status === 0) {
          if (!response.data.data.buttonPerm) {
            response.data.data.buttonPerm = []
          }
          commit('updateMenuPermission', {
            // menuPermission: permission.selectedMenu(
            //   response.data.data.menuPerm
            // ),
            // buttonPermission: permission.selectedButtons(
            //   response.data.data.buttonPerm
            // )
            menuPermission: response.data.data.menuPerm,
            buttonPermission: response.data.data.buttonPerm
          })
          setItem('mp', JSON.stringify(response.data.data.menuPerm))
          setItem('bp', JSON.stringify(response.data.data.buttonPerm))
          dispatch('initPerms')
          // 看发布中心
          dispatch('changeBtnPerm')
          dispatch('save', true)
        }
      })
    },
    initPerms: ({ getters }) => {
      if (!Vue.prototype.$_has) {
        Vue.prototype.$_has = function(permArray) {
          let perms = []
          let buttonPerms = getters.buttonPermission
          perms = Array.isArray(permArray)
            ? [...permArray]
            : typeof permArray === 'string'
            ? [permArray]
            : perms
          return perms.some((perm) => {
            return buttonPerms.indexOf(perm) !== -1
          })
        }

        Vue.directive('has', {
          bind: function(el, binding) {
            if (!Vue.prototype.$_has(binding.value)) {
              el.style.display = 'none'
            }
          },
          inserted: function(el, binding) {
            if (!Vue.prototype.$_has(binding.value)) {
              el.parentNode.removeChild(el)
            }
          }
        })
      }
    },
    changeBtnPerm({ commit }) {
      let str = new Date().getTime()
      commit('comchangeBtnPerm', str)
    },
    setUploaderState({ commit, dispatch }, value) {
      commit('updateUploaderState', value)
      dispatch('init')
    },
    setUpdateFileArr({ commit }, arr) {
      commit('updateFileArr', arr)
      arr.map((file) => {
        store.state.uploaderState.upload(file)
      })
    },
    init: ({ dispatch }) => {
      store.state.uploaderState.on('uploadBeforeSend', function(
        // 在发送文件之前 需要把每个文件的uuid及刊物id放到data中
        obj,
        data
      ) {
        let arr = store.state.fileMagazinedArray
        data.userId = store.state.userInfo.userId
        for (let j = 0; j < arr.length; j++) {
          if (arr[j].id === data.id && arr[j].name === data.name) {
            data.targetPath = arr[j].uuid
            data.magazineId = arr[j].magazineId
            data.sectionId = arr[j].sectionId
            setTimeout(() => {
              if (arr[j]) {
                arr[j].isTimeout = true
              }
            }, 3000000)
          }
        }
      })
      // 文件上传过程中进度
      store.state.uploaderState.on('uploadProgress', (file, percentage) => {
        let obj = {}
        obj.sectionId = file.sectionId
        // 假如文件超时的话
        if (file.isTimeout) {
          obj.percentage = false
          dispatch('articleUploadFaild', file.sectionId)
          store.state.uploaderState.cancelFile(file)
        } else {
          obj.percentage = percentage * 100
        }
        store.state.filePercentageObj = obj
      })
      // 上传成功后
      store.state.uploaderState.on('uploadSuccess', (file, response) => {
        let arr = store.state.fileMagazinedArray
        if (response.status === 0) {
          for (var j = 0; j < arr.length; j++) {
            if (
              arr[j].name === file.name &&
              response.data.fileId &&
              response.data.fileId !== ''
            ) {
              arr[j].fileId = response.data.fileId
              arr.splice(j, 1)
            }
          }
          if (arr.length === 0) {
            localStorage.setItem('fileFailedIds', '')
          }
        }
      })
      // 上传失败
      store.state.uploaderState.on('uploadError', (file, reason) => {
        console.log('上传失败', reason)
        // 针对用户网络慢或者服务器报错情况处理
        dispatch('articleUploadFaild', file.sectionId)
      })
      // 上传失败
      store.state.uploaderState.on('error', () => {})
    },
    // 上传超时以及刷新关闭失败处理
    articleUploadFaild(id) {
      let arr = store.state.fileMagazinedArray
      let params = {
        sectionId: id,
        userId: store.state.userInfo.userId,
        type: 2,
        uploadType: 'upload'
      }
      Get('/article/articleUploadFaild.do', { params: params }).then(
        (response) => {
          if (response.data.status === 0) {
            for (var j = 0; j < arr.length; j++) {
              if (id === arr[j].sectionId) {
                arr.splice(j, 1)
              }
            }
          } else {
            new Vue().$message({
              message: response.data.message,
              type: 'error',
              duration: 1500
            })
          }
        }
      )
    },
    updateActiveMenu({ commit }, value) {
      commit('updateActive', value)
    }
  }
}
export default store
